<template>
  <div>
    <Table :columns="columns" :data="resources" size="small" :loading="loading" highlight-row stripe max-height="700"
      :show-summary="true" :summary-method="handleSummary">
      <template slot-scope="{ row }" slot="product_name">
        <Tooltip :content="row.product_name_kh" placement="top-start" max-width="500" theme="light" :delay="500">
          <div class="ts-whitespace-no-wrap ts-cursor-pointer">
            {{ row.product_name_kh ? row.product_name_kh : '' }}
          </div>
        </Tooltip>
      </template>
      <template slot-scope="{ row }" slot="ending_balance">
        <b>{{ row.ending_balance }}</b>
      </template>
      <template slot-scope="{ row }" slot="unitCostUSD">
        <b>
          {{ formatCurrency((row.cost ? row.cost : 0)) }}
        </b>
      </template>
      <template slot-scope="{ row }" slot="unitCostTHB">
        <b>
          {{ formatCurrency((row.cost ? row.cost * 32 : 0)) }}
        </b>
      </template>
      <template slot-scope="{ row }" slot="totalCostUSD">
        <b>{{ formatCurrency((row.cost_amount ? row.cost_amount : 0))
          }}
        </b>
      </template>
      <template slot-scope="{ row }" slot="totalCostTHB">
        <b>{{ formatCurrency((row.cost_amount ? row.cost_amount * 32 : 0)) }}</b>
      </template>
    </Table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'DetailByItems',
  props: ['summary'],
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('report/productNonMovingStock', ['resources']),
    columns() {
      return [
        {
          title: this.$t('productNonMovingStock.no'),
          key: 'no',
          width: 60,
          render: (h, params) => {
            return h('span', [params.index + 1])
          },
          align: 'center'
        },
        {
          title: this.$t('productNonMovingStock.branch'),
          key: 'branch_name_en',
          minWidth: 110
        },
        {
          title: this.$t('productNonMovingStock.wareHouse'),
          key: 'location_name',
          minWidth: 130
        },
        {
          title: this.$t('productNonMovingStock.category'),
          key: 'category',
          minWidth: 110
        },
        {
          title: this.$t('productNonMovingStock.group'),
          key: 'product_group',
          minWidth: 110
        },
        {
          title: this.$t('productNonMovingStock.barcode'),
          key: 'barcode',
          minWidth: 120
        },
        {
          title: this.$t('productNonMovingStock.product'),
          key: 'product_name',
          slot: 'product_name',
          minWidth: 300
        },
        {
          title: this.$t('productNonMovingStock.storage'),
          key: 'storage_location',
          minWidth: 90
        },
        {
          title: this.$t('productNonMovingStock.balance'),
          slot: 'ending_balance',
          key: 'ending_balance',
          minWidth: 90,
          align: 'center'
        },
        {
          title: this.$t('productNonMovingStock.unitCostUSD'),
          slot: 'unitCostUSD',
          minWidth: 120,
          align: 'right'
        },
        {
          title: this.$t('productNonMovingStock.unitCostTHB'),
          slot: 'unitCostTHB',
          minWidth: 120,
          align: 'right'
        },
        {
          title: this.$t('productNonMovingStock.totalCostUSD'),
          slot: 'totalCostUSD',
          key: 'totalCostUSD',
          minWidth: 140,
          align: 'right'
        },
        {
          title: this.$t('productNonMovingStock.totalCostTHB'),
          slot: 'totalCostTHB',
          key: 'totalCostTHB',
          minWidth: 140,
          align: 'right'
        }
      ]
    }
  },
  methods: {
    formatCurrency(amount) {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4
      }).format(amount)
    },
    handleSummary({ columns, data }) {
      const sums = {}
      columns.forEach((column, index) => {
        const key = column.key
        if (index === 2) {
          sums[key] = {
            key,
            value: this.$t('productNonMovingStock.total')
          }
          return
        }
        if (key === 'category') {
          sums[key] = {
            key,
            value: this.summary.total_category
          }
        } else if (key === 'product_group') {
          sums[key] = {
            key,
            value: this.summary.total_group
          }
        } else if (key === 'product_name') {
          sums[key] = {
            key,
            value: this.summary.total_product
          }
        } else if (key === 'ending_balance') {
          sums[key] = {
            key,
            value: this.summary.total_ending_balance
          }
        } else if (key === 'totalCostUSD') {
          const sumTotalUSD = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
          }).format(this.summary.total_cost_amount_usd)

          sums[key] = {
            key,
            value: sumTotalUSD
          }
        } else if (key === 'totalCostTHB') {
          const sumTotalTBH = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
          }).format(this.summary.total_cost_amount_bath)

          sums[key] = {
            key,
            value: sumTotalTBH
          }
        } else {
          sums[key] = {
            key,
            value: ''
          }
        }
      })

      return sums
    }
  }
}
</script>
